module.exports = __webpack_public_path__ + "img/5.4d12d4f1.png";